/* eslint no-unused-vars: "off" */
import React, { useContext, useState } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useIntersectionObserver } from 'usehooks-ts';
import Card from '../_common/card/Card';
import {
  FeedbackCardWrapper,
  ContentWrapper,
  Content,
  YesButton,
  NoButton,
  IconContainer,
  ButtonWrapper,
  TextContainer,
  SubmissionStatus,
} from './FeedbackCard.styles';
import CheckIcon from '../../assets/CheckIcon';
import ChatBubbleIcon from '../../assets/ChatBubbleIcon';
import { AnalyticEvents } from '../../constants';

type FeedbackCardProps = {
  cardPosition: number;
};

const FeedbackCard = ({ cardPosition }: FeedbackCardProps) => {
  const [isSubmitted, setSubmitted] = useState(false);
  const { trackEvent } = useContext(AnalyticsContext) as any;

  const cardId = 25;

  // Register click event
  const handleClick = (clickedBtnValue: string) => {
    trackEvent(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
      feedbackResponse: clickedBtnValue,
    });
    datadogRum.addAction(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
      feedbackResponse: clickedBtnValue,
    });
    setSubmitted(true);
  };

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  const header = {
    title: 'Share Your Feedback',
  };

  return (
    <FeedbackCardWrapper ref={ref}>
      <Card dataQa="feedback" header={header} headerIcon={<ChatBubbleIcon />}>
        <ContentWrapper>
          <Content>
            <TextContainer data-testid="feedback-card-prompt-text">Was this page helpful?</TextContainer>
          </Content>
          {!isSubmitted && (
            <ButtonWrapper>
              <YesButton data-testid="feedback-card-yes-button" size="small" onClick={() => handleClick('yes')}>
                Yes
              </YesButton>
              <NoButton data-testid="feedback-card-no-button" size="small" onClick={() => handleClick('no')}>
                No
              </NoButton>
            </ButtonWrapper>
          )}
          {isSubmitted && (
            <SubmissionStatus data-testid="feedback-card-confirmation-text">
              <IconContainer>
                <CheckIcon />
              </IconContainer>
              Thanks for the feedback.
            </SubmissionStatus>
          )}
        </ContentWrapper>
      </Card>
    </FeedbackCardWrapper>
  );
};

export default FeedbackCard;
